import type { Static } from 'runtypes';
import * as rt from 'runtypes';

const UserEventOverviewRuntype = rt.Record({
  session_id: rt.String,
  event: rt.String,
  event_time: rt.InstanceOf(Date),
  event_id: rt.String,
  user_id: rt.Number,
  timezone: rt.Optional(rt.String),
  brief_id: rt.Optional(rt.Number),
  artifact_id: rt.Number,
  artifact_type: rt.String,
  artifact_operation: rt.String,
  menu_item_clicked: rt.String,
  brief_created_at: rt.InstanceOf(Date),
  brief_created_by: rt.Number,
  first_name: rt.String,
  last_name: rt.String,
  user_organizations: rt.Array(rt.String),
  user_groups: rt.Array(rt.String),
  email: rt.String,
  job_title: rt.Optional(rt.String),
  rank: rt.Optional(rt.String),
  organization: rt.Optional(rt.String),
  parent_organization: rt.Optional(rt.String),
  board_artifact_type: rt.Optional(rt.String),
  artifact_creator: rt.Number,
  artifact_home_brief: rt.Number,
  page_type: rt.Optional(rt.String),
});

type UserEventOverviewType = Static<typeof UserEventOverviewRuntype>;

export { UserEventOverviewRuntype };
export type { UserEventOverviewType };
